<template>
  <b-card>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template slot="bottom-row" slot-scope="data">
        <td align="right" :span="data.columns" colspan="5">
          <b>Grand Total (RM)</b>
        </td>
        <td :span="data.columns">{{ grand.toFixed(4) }}</td>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    grand: {
      type: Number
    }
  },
  methods: {}
};
</script>
<style lang="css" scoped></style>
